import { useQuery } from '@tanstack/react-query'
import { UseFormSetValue } from 'react-hook-form'
import ConstantsApiService from 'services/constantsApiService'

export type PlannedEventsFormValues = {
	next_trim_fixed_days: string
}

export const usePlannedEventsInfo = (
	setValue: UseFormSetValue<PlannedEventsFormValues>,
) => {
	const { data, isLoading, error } = useQuery({
		queryKey: ['health-event-constants'],
		queryFn: () =>
			ConstantsApiService.getConstants().then(res => {
				setValue('next_trim_fixed_days', String(res.data.next_trim_fixed_days))
			}),
	})

	return { isLoading, error }
}

export const defaultValues: PlannedEventsFormValues = {
	next_trim_fixed_days: '',
}
